import "./style.scss"

const Sidebar = () => <aside className="sidebar">
  <h2 className="marketingHeader">With Portfolio Intelligence...</h2>
  <div className="marketingFeature">
    <i className="fa fa-tachometer" />
    <div className="marketingTitle">Status</div>
    <p className="marketingDescription">Quickly view key financial stats</p>
  </div>
  <div className="marketingFeature">
    <i className="fa fa-line-chart" />
    <div className="marketingTitle">Analyze</div>
    <p className="marketingDescription">Explore how factors affect your portfolio</p>
  </div>
  <div className="marketingFeature">
    <i className="fa fa-sliders" />
    <div className="marketingTitle">Simulate</div>
    <p className="marketingDescription">Understand which portfolio changes & trades help you reach your targets</p>
  </div>
</aside>

Sidebar.displayName = "Sidebar"

export default Sidebar
